import { Box, Slider, Typography } from "@mui/material";

import { Layer } from "../../types/layer";
import LayerControlItem from "./LayerControlItem";

interface GrassCuringControlProps {
  layer: Layer | null;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  onPanelOpenChange?: (open: boolean) => void;
}

/**
 * Toggle for the grass-curing overlay, with an opacity slider.
 *
 * Curing is a backdrop you read other things against — treatments, assets,
 * a fire perimeter — so how strongly it paints is a judgement that changes
 * with what you are looking at, not a constant worth hardcoding.
 */
const GrassCuringControl: React.FC<GrassCuringControlProps> = ({
  layer,
  expanded,
  onExpandedChange,
  onPanelOpenChange,
}) => {
  if (!layer) return null;

  const handleToggleVisibility = () => {
    layer.toolbarButton?.props?.onClick?.();
  };

  const opacity = layer.opacity ?? 0.95;
  const setOpacity = layer.setOpacity;

  const opacityControl = setOpacity ? (
    <Box sx={{ px: 0.5, minWidth: 180 }}>
      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
        Opacity: <b style={{ color: "#fff" }}>{Math.round(opacity * 100)}%</b>
      </Typography>
      <Slider
        value={Math.round(opacity * 100)}
        onChange={(_, value) => setOpacity((value as number) / 100)}
        min={10}
        max={100}
        step={5}
        size="small"
        aria-label="Grass curing layer opacity"
        sx={{ color: "#7cb342" }}
      />
    </Box>
  ) : null;

  return (
    <LayerControlItem
      title="Grass Curing"
      icon="grass"
      visible={layer.active ?? false}
      onToggleVisibility={handleToggleVisibility}
      enabled={layer.toolbarButton?.props?.enabled ?? false}
      disabledReason={layer.unavailableReason}
      drawingContent={opacityControl}
      drawingContentLabel="Display"
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onPanelOpenChange={onPanelOpenChange}
    />
  );
};

export default GrassCuringControl;
